import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cohome',
  templateUrl: './cohome.component.html',
  styleUrls: ['./cohome.component.css']
})
export class CohomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
